import {ActionCompletionDialogComponent} from '../action-completion-dialog/action-completion-dialog.component';
import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {ConfirmActionDialogComponent} from '../confirm-action-dialog/confirm-action-dialog.component';
import {LoadingService} from '../../services/loading.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {PurchaseOrdersService} from '../../services/purchase-orders.service';
import {environment} from '../../../environments/environment';

@Component({
  styleUrls: ['./assign-and-detail-modal.component.scss'],
  templateUrl: './assign-and-detail-modal.component.html'
})
export class AssignAndDetailModalComponent implements OnInit {
  public type: number;
  public dataFields: any;
  public title: string;
  public placeHolders: string[];
  public userSalePoint: any;
  public selectedCommand: any;
  public imageFilesSource: any[];

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<AssignAndDetailModalComponent>,
              private purchaseOrdersService: PurchaseOrdersService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = this.data.type;
    this.dataFields = [];
    this.imageFilesSource = [];
    this.userSalePoint = this.data.userSalePoint;
    this.selectedCommand = null;
  }

  public ngOnInit(): void {
    let request;
    this.title = this.type === 0 ? 'Πληροφορίες ψυγείου' : 'Ανάθεση εντολής επιστροφής';

    request = this.type === 0 ? {url: 'refrigerator', filter: `serial_number='${this.data.serial_number}'`, options: false} : {
      url: 'return_command/web',
      filter: `status_id=6`,
      options: false
    };
    if (this.type === 0 && !this.data.serial_number) {
      this.noInfo();
    } else {
      this.purchaseOrdersService.getList(request.url, request.filter, request.options).then(data => {

        if (this.type === 0) {
          if (data.length > 0) {
            const d = data[0];
            delete d.is_new;
            delete d.is_new_id;
            delete d.phase_id;
            delete d.is_active;
            delete d.sales_group_id;
            delete d.last_repair_date;
            delete d.can_be_loaded;
            delete d.can_be_received;
            delete d.can_be_returned;
            delete d.can_be_unloaded;
            const keys = Object.keys(data[0]);
            this.placeHolders = ['Αριθμός Ψυγείου', 'Σειριακός Αριθμός Ψυγείου', 'Κωδικός Είδους', 'Είδος', 'Παρτίδα',
              'Εικαστικό', 'Καθαρό Βάρος', 'Κωδικός Μοντέλου', 'Μόντέλο', 'Ποιότητα',
              'Κατασκευαστής', 'Κωδικός Εξοπλισμού', 'Σημείο Πώλησης', 'Διεύθυνση', 'Δρομολόγιο', 'Κατάσταση'];
            keys.forEach(key => {
              if (key !== 'batch_id' && key !== 'eikastiko_id' && key !== 'quality_id' &&
                key !== 'manufacturer_id' && key !== 'sale_point_id' &&
                key !== 'sale_point_customer_code') {
                const model = {
                  key,
                  value: data[0][key]
                };
                this.dataFields.push(model);
              }
            });
          } else {
            this.noInfo();
          }
        } else {
          this.dataFields = data;
        }
      });
    }
  }

  public noInfo(): void {
    // this.loadingService.show();

    try {
      const filter = `id=${this.data.refrigeratorId}`;
      this.commonService.getListWithParameters(`return_command/web/details/files?id=${this.data.refrigeratorId}`, null)
        .then((files: any) => {
        for (const file of files) {
          const imageFile = `${environment.apiUrl}files?name=${file.file_name}&model=return_command`;
          this.imageFilesSource.push(imageFile);
        }
      });
    } catch (e) {
      this.imageFilesSource = [];
    } finally {
      this.loadingService.hide();
    }
  }

  public commandSelectionChange(command) {
    this.selectedCommand = command;
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public confirmAssignment(): void {
    this.matDialog.open(ConfirmActionDialogComponent, {
      data: {
        confirmFunction: async () => {
          await this.assignCommandToUser({salePointId: this.userSalePoint[0].id, commandId: this.selectedCommand.id});
        },
        message: `Είστε σίγουροι ότι θέλετε να αναθέσετε ως παραλήπτη: ${this.userSalePoint[0].customer_name}  για την εντολή επιστροφής με αριθμό : ${this.selectedCommand.id}?`,
        title: 'Ανάθεση εντολής'
      }
    });
  }

  public isDisabled(): boolean {
    return this.selectedCommand === null;
  }

  public async assignCommandToUser(object: any): Promise<void> {
    try {
      await this.purchaseOrdersService.updateReceiptCommand(`return_command/web/routing/${object.commandId}`,
        {recipient_sale_point_id: object.salePointId});
      this.matDialog.open(ActionCompletionDialogComponent, {
        data: {
          buttonText: 'Πλοήγηση στις επιστροφές ψυγείων',
          redirectURL: `returns`
        }
      });
    } catch (e) {
    }
  }
}
